import React, { useContext, ReactElement } from 'react';
import { TabContext } from './Tabs';

interface TabProps {
  index: number;
  label: string;
  icon: ReactElement<{ size?: number; weight?: string }>;
}

const Tab: React.FC<TabProps> = ({ index, label, icon }) => {
  const context = useContext(TabContext);

  if (!context) {
    throw new Error('Tab must be used within a Tabs component.');
  }

  const { activeIndex, setActiveIndex } = context;
  const isActive = activeIndex === index;

  const styledIcon = React.cloneElement(icon, {
    weight: isActive ? 'bold' : 'regular',
  });

  return (
    <button
      id="tab-item"
      className={`flex items-center space-x-1 font-inter ${
        activeIndex === index
          ? 'border-b-2 border-primary-700 font-bold text-primary-700'
          : 'text-gray-600'
      } px-3 py-1 hover:text-primary-500`}
      onClick={() => setActiveIndex(index)}
    >
      {icon && <span id="tab-icon">{styledIcon}</span>}
      <span id="tab-label" className="text-xs sm:text-sm">
        {label}
      </span>
    </button>
  );
};

export default Tab;
